import { useCallback, useMemo } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useTriggerShareVisualModal } from 'src/app/pages/starterDashboardV2/shared/hooks';
import { useLocale } from 'src/app/shared/hooks/l10n';

type UseShareSocialData = { shareVisual: { enabled: boolean } };
type UseShareSocialActions = { onShareVisualDownload: () => Promise<void> };
type UseShareSocialReturn = ModelHookResult<UseShareSocialData, UseShareSocialActions>;
export function useShareSocial(): UseShareSocialReturn {
	const {
		data: {
			featureConfigs: { shareVisualsConfig },
		},
	} = useStarterDashboardV2PageData();
	const locale = useLocale();

	const shareVisual = useMemo(() => {
		const disabled = { enabled: false } as const;
		if (!shareVisualsConfig) return disabled;
		if (!shareVisualsConfig.enabled) return disabled;
		if (!shareVisualsConfig.locales.includes(locale)) return disabled;

		return { enabled: true } as const;
	}, [locale, shareVisualsConfig]);

	const openShareVisualModal = useTriggerShareVisualModal('starter_dashboard_grow_petition');

	const track = useTracking();
	const onShareVisualDownload = useCallback(async () => {
		void track('petition_social_content_download_click');
		await openShareVisualModal();
	}, [openShareVisualModal, track]);

	return {
		data: { shareVisual },
		actions: { onShareVisualDownload },
	};
}
